export default [
  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/user/Index.vue'),
    meta: {
      pageTitle: 'User',
      breadcrumb: [
        {
          text: 'User',
          active: true,
        },
      ],
    },
  },
  {
    path: '/user/add',
    name: 'user-add',
    component: () => import('@/views/user/Create.vue'),
    meta: {
      pageTitle: 'User',
      breadcrumb: [
        {
          text: 'User',
          to: '/user',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/user/edit',
    name: 'user-edit',
    component: () => import('@/views/user/Edit.vue'),
    meta: {
      pageTitle: 'User',
      breadcrumb: [
        {
          text: 'User',
          to: '/user',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/role',
    name: 'role',
    component: () => import('@/views/role/Index.vue'),
    meta: {
      pageTitle: 'Role',
      breadcrumb: [
        {
          text: 'Role',
          active: true,
        },
      ],
    },
  },
  {
    path: '/role/add',
    name: 'role-add',
    component: () => import('@/views/role/Create.vue'),
    meta: {
      pageTitle: 'Role',
      breadcrumb: [
        {
          text: 'Role',
          to: '/role',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
];
